<template>
  <div class="main">
    <Result
      error
      :title="t('CL_WITHDRAWAL.IDENTITY_VERIFICATION_REJECTION_TITLE')"
      :description="
        t('CL_WITHDRAWAL.IDENTITY_VERIFICATION_REJECTION_DESCRIPTION')
      "
      :btn-text="t('CL_WITHDRAWAL.GO_TO_HOME_BTN')"
      @dismissFunc="dismiss()"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Result from "@/apps/credit-line/components/Result.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
declare const Android: AndroidInterface;
export default defineComponent({
  name: "WithdrawalRejectionView",
  components: { Result },
  methods: {
    dismiss() {
      Android.dismissWebView();
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";
</style>
